module.exports = __webpack_public_path__ + "img/voice.35c3c1b9.svg";